export default {
	LIBRARY: 'library',
	STORE_LANDING: 'store-landing',
	STORE_SEARCH: 'store-search',
	CT_CREATE: 'create',
	CT_ADMIN: 'admin',
	APP_CHECKOUT: 'checkout',
	CT_REFERRAL: 'referral',
	MY_ACCOUNT: 'my-account',
	STORE_FOLDER: 'store-folder',
	STORE_PREVIEW: 'store-preview',
	INTERACTIVE_VIDEO_SELECT: 'interactive-video-select',
	INTERACTIVE_VIDEO_CREATE: 'interactive-video-create',
	INTERACTIVE_VIDEO_CREATION_OEQ: 'interactive-video-creation-oeq',
	INTERACTIVE_VIDEO_CREATION_MCQ: 'interactive-video-creation-mcq',
	INTERACTIVE_VIDEO_SCREENSHOT: 'interactive-video-screenshot',
	VIDEO_CREATE: 'video-create',
	VIDEO_CREATION_OEQ: 'video-creation-oeq',
	VIDEO_CREATION_MCQ: 'video-creation-mcq',
	SCHOOL_LIBRARY: 'school',
	DISTRICT_LIBRARY: 'district',
	PUBLIC_LIBRARY: 'public-library',
	PUBLIC_LIBRARY_ADMIN: 'public-library-admin',
	SUB_PLANS: 'sub-plans',
	PRIVATE_LIBRARY: 'private-library',
	CONTENT_PACKAGES: 'ayce',
	SUPPLEMENTAL_CURRICULUM: 'supplemental-curriculum',
	REPORTS: 'reports',
	TEACHER_RESOURCES: 'teacher-resources',
	GOOGLE_SLIDES_SIDEBAR: 'google-slides-sidebar',
	STANDALONE_ACTIVITY: 'standalone-activity',
	OEQ_CREATION: 'oeq-creation',
	DRAW_IT_CREATION: 'draw-it-creation',
	DRAW_IT_STANDALONE_CREATION: 'draw-it-standalone-creation',
	QUIZ_CREATION: 'quiz-creation',
	POLL_CREATION: 'poll-creation',
	MATCHING_PAIRS_CREATION: 'matching-pairs-creation',
	MATCHING_PAIRS_STANDALONE_CREATION: 'matching-pairs-standalone-creation',
	FLOCABULARY_CREATION: 'flocabulary-creation',
	DESMOS_CREATION: 'desmos-creation',
	TIME_TO_CLIMB_CREATION: 'time-to-climb-creation',
	TIME_TO_CLIMB_STANDALONE_CREATION: 'time-to-climb-standalone-creation',
	STORE_LOCKED_CONTENT: 'store-locked-content',
	ONBOARDING_ACTIVITY: 'onboarding-activity',
	UPGRADE_ACCOUNT: 'upgrade',
	MY_ACTIVITIES: 'my-activities',
	QUICK_LAUNCH_OEQ_ACTIVITY_CREATION: 'quick-launch-oeq-activity-creation',
	QUICK_LAUNCH_DRAW_IT_ACTIVITY_CREATION: 'quick-launch-draw-it-activity-creation',
	QUICK_LAUNCH_FIELD_TRIP_ACTIVITY_CREATION: 'quick-launch-field-trip-activity-creation',
	QUICK_LAUNCH_TIMER_ACTIVITY_CREATION: 'quick-launch-timer-activity-creation',
	QUICK_LAUNCH_TIMER: 'quick-launch-timer',
	FLIPGRID_CREATION: 'flipgrid-creation',
	POLL_STUDENT: 'StudentPoll',
	QUIZ_STUDENT: 'StudentQuiz',
	OEQ_STUDENT: 'StudentOeq',
	SLIDESHOW_STUDENT: 'Slideshow', //@todo: hmike: use 'SlideshowStudent' instead
	MY_LIBRARY: 'MyLibrary',
	INTERACTIVE_VIDEO_SESSION: 'interactive-video-session',
	INTERACTIVE_VIDEO_PREVIEW: 'interactive-video-preview',
	VIDEO_STANDALONE_CREATE: 'video-standalone-create',
	VIDEO_STANDALONE_CREATION_OEQ: 'video-standalone-creation-oeq',
	VIDEO_STANDALONE_CREATION_MCQ: 'video-standalone-creation-mcq',
	SCHOOL_ADMIN: 'school-admin',
	DISTRICT_ADMIN: 'district-admin',
	LEAD_PAGE: 'StudentLeadPage',
	MANAGE_NEARPOD: 'manage-nearpod',
	SESSION_PREVIEW: 'session-preview',
}
